import { Action } from 'redux';
import { Paciente } from '../../../models/Entities/Turnero';
import { TurneroPacientesState, TurneroPacientesUnloadState } from '../../states/Turnero-Pacientes.State';

export default function TurneroPacientesReducer(
    state: TurneroPacientesState | undefined,
    action: Action
): TurneroPacientesState {
    const currentState = state ?? TurneroPacientesUnloadState;
    const a: any = action;

    switch (a.type) {
        case 'TURNERO-PACIENTES_GET_ALL_REQUEST':
            return {
                ...currentState,
                isLoadingAll: true,
                successLoadingAll: false,
                failOnLoadingAll: false,
                error: undefined
            } as TurneroPacientesState;
        case 'TURNERO-PACIENTES_GET_ALL_SUCCESS':
            return {
                ...currentState,
                isLoadingAll: false,
                successLoadingAll: true,
                failOnLoadingAll: false,
                error: undefined,
                list: a.payload || []
            } as TurneroPacientesState;
        case 'TURNERO-PACIENTES_GET_ALL_FAILURE':
            return {
                ...currentState,
                isLoadingAll: false,
                successLoadingAll: false,
                failOnLoadingAll: true,
                error: a.error
            } as TurneroPacientesState;

        case 'TURNERO-PACIENTES_CREATE_REQUEST':
            return {
                ...currentState,
                isAddingNewOne: true,
                successAddingNewOne: false,
                failOnAddingNewOne: false,
                error: undefined
            } as TurneroPacientesState;
        case 'TURNERO-PACIENTES_CREATE_SUCCESS':
            return {
                ...currentState,
                isAddingNewOne: false,
                successAddingNewOne: true,
                failOnAddingNewOne: false,
                error: undefined,
                list: [...(currentState.list || []), a.payload]
            } as TurneroPacientesState;
        case 'TURNERO-PACIENTES_CREATE_FAILURE':
            return {
                ...currentState,
                isAddingNewOne: false,
                successAddingNewOne: false,
                failOnAddingNewOne: true,
                error: a.error
            } as TurneroPacientesState;

        case 'TURNERO-PACIENTES_GET_BY_ID_REQUEST':
            return {
                ...currentState,
                isLoadingOne: true,
                successLoadingOne: false,
                failOnLoadingOne: false,
                error: undefined
            } as TurneroPacientesState;
        case 'TURNERO-PACIENTES_GET_BY_ID_SUCCESS': {
            const updatedList = [...(currentState.list || []).filter((p: Paciente) => p.id !== a.payload.id), a.payload];
            return {
                ...currentState,
                isLoadingOne: false,
                successLoadingOne: true,
                failOnLoadingOne: false,
                error: undefined,
                current: a.payload,
                list: updatedList
            } as TurneroPacientesState;
        }
        case 'TURNERO-PACIENTES_GET_BY_ID_FAILURE':
            return {
                ...currentState,
                isLoadingOne: false,
                successLoadingOne: false,
                failOnLoadingOne: true,
                error: a.error
            } as TurneroPacientesState;

        case 'TURNERO-PACIENTES_GET_EN_COLA_REQUEST':
            return {
                ...currentState,
                isLoadingEnCola: true,
                successLoadingEnCola: false,
                failOnLoadingEnCola: false,
                error: undefined
            } as TurneroPacientesState;
        case 'TURNERO-PACIENTES_GET_EN_COLA_SUCCESS':
            return {
                ...currentState,
                isLoadingEnCola: false,
                successLoadingEnCola: true,
                failOnLoadingEnCola: false,
                error: undefined,
                enCola: a.payload || []
            } as TurneroPacientesState;
        case 'TURNERO-PACIENTES_GET_EN_COLA_FAILURE':
            return {
                ...currentState,
                isLoadingEnCola: false,
                successLoadingEnCola: false,
                failOnLoadingEnCola: true,
                error: a.error
            } as TurneroPacientesState;

        default:
            return currentState as TurneroPacientesState;
    }
}
